<template>
  <!--个人主页页面-->
  <tk-container
    :status="status"
    :disable-scroll="!isUpShelf"
    @refresh="getInit"
    class="b-g-f"
  >
    <!--头部-->
    <my-header :icon="'fanhui'" slot="header"></my-header>
    <!--个人信息-->
    <div slot="header">
      <div style="height: 15px;"></div>
      <tk-flex
        between
        middle
        class="m-x-12 mine-bg-color"
      >
        <tk-flex middle class="full-width">
          <tk-avatar size="50">
            <tk-image :src="avatarSrc" width="50" height="50"></tk-image>
          </tk-avatar>
          <div class="m-l-10">
            <tk-flex middle class="font-20 font-bold">
              {{fullName}}
              <span v-if="isCountyAccount" class="bg-color-level m-l-10">{{levelName | membershipLevel}}</span>
            </tk-flex>
            <div style="width: 100%;margin-left: 1px;">
             <textarea
               :disabled="profileId !== this.userInfo.objectId"
               :placeholder="'介绍下自己'"
               rows="3"  maxlength="25"
               onchange="this.value=this.value.substring(0, 25)"
               @blur.prevent="getBlur()"
               contenteditable="true"
               class="comments-area fill p-y-5"
               name="opinion"
               id="postsTextarea"
               cols="40"
               v-model="signature"
             >
              </textarea>
            </div>
          </div>
        </tk-flex>
        <div class="font-12 m-b-8">
          <tkui-button v-if="profileId === userInfo.objectId" @click="$push('/itsMine/myProfile')" class="small primary rounded bg-color-edit">编辑资料</tkui-button>
          <tkui-button v-else-if="watchText && profileId !== userInfo.objectId" @click="liftOrWatch" :disabled="watchDisabled" class="small primary rounded bg-color-edit">{{watchText}}</tkui-button>
        </div>
      </tk-flex>
      <!--帖子相关信息-->
      <tk-flex v-if="!isUpShelf" around class="m-x-12 p-y-15">
        <tk-flex
          column
          center
          @click.native="$push({path: '/common/postsList', query: {type: 'post', id: profileId}})"
          class="tk-grid-3"
        >
          <div class="font-20 font-bold">{{postsSum | transform}}</div>
          <div class="caption m-t-5" style="font-size: 15px !important;">发帖</div>
        </tk-flex>
        <tk-flex
          column
          center
          @click.native="$push({path: '/common/userList', query: {type: 'watch', id: profileId}})"
          class="tk-grid-3"
        >
          <div class="font-20 font-bold">{{watchSum | transform}}</div>
          <div class="caption m-t-5" style="font-size: 15px !important;">关注</div>
        </tk-flex>
        <tk-flex
          column
          center
          @click.native="$push({path: '/common/userList', query: {type: 'fans', id: profileId}})"
          class="tk-grid-3"
        >
          <div class="font-20 font-bold">{{fansSum | transform}}</div>
          <div class="caption m-t-5" style="font-size: 15px !important;">粉丝</div>
        </tk-flex>
        <tk-flex
          column
          center
          @click.native="$push({path: '/itsMine/praisePosts', query: {id: profileId}})"
          class="tk-grid-3"
        >
          <div class="font-20 font-bold">{{praiseNum | transform}}</div>
          <div class="caption m-t-5" style="font-size: 15px !important;">获赞</div>
        </tk-flex>
      </tk-flex>
      <!--分割线-->
      <div class="mine-line"></div>
    </div>
    <!--tab切换-->
    <tkui-tab v-if="!isUpShelf" around style="height: 1000px;">
      <tkui-tab-item label="发帖">
        <posts-container :posts-type="'post'" :profile-id="profileId"></posts-container>
      </tkui-tab-item>
      <tkui-tab-item label="评论">
        <posts-container :posts-type="'comment'" :profile-id="profileId"></posts-container>
      </tkui-tab-item>
      <tkui-tab-item label="点赞">
        <posts-container :posts-type="'like'" :profile-id="profileId"></posts-container>
      </tkui-tab-item>
    </tkui-tab>
    <!--热榜排行渲染-->
    <div class="m-t-8" v-else>
      <div class="m-x-12" v-if="hotList.length">
        <card
          :height="100"
          :width="100"
          class="m-t-8 p-y-8"
          v-for="(s, index) in hotList"
          :key="`up-shelf${index}`"
        >
          <lookCommodity
            :commodity="s"
            :list-index="index"
            :is-show-selling="false"
            :is-border="false"
            :bg-color="'#E2C492'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
          >
            <div class="class-card-sales m-t-4" slot="sales">累计热销 {{s.sales ? s.sales : 0}}件</div>
          </lookCommodity>
        </card>
      </div>
      <div class="m-x-12" v-else>
        <card :height="100" class="m-t-8">
          <empty-tips :height="100" :width="100" :empty-msg="'暂无热卖数据'"></empty-tips>
        </card>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { judgePosts } from '@/assets/help/posts'
import postsContainer from '@/components/postsContainer'
import lookCommodity from '@/components/lookCommodity'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    postsContainer,
    lookCommodity
  },
  data () {
    return {
      status: 'loading', // 页面状态
      signature: '', // 签名
      timeRule: {}, // 限时抢购时间规则
      hotList: [], // 热卖排行
      profileUser: null, // 个人主页用户信息
      postsProfile: null, // 个人主页信息
      watchStatus: false, // 关注状态
      watchDisabled: false, // 关注按钮状态
      watchRecord: null, // 关注记录
      watchText: '', // 关注文字
      postsSum: 0, // 发帖数
      praiseNum: 0, // 获赞数
      watchSum: 0, // 关注数
      fansSum: 0 // 粉丝数
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus()
      },
      componentUpdated: function (el) {
        el.focus()
      }
    }
  },
  computed: {
    // 个人主页用户Id
    profileId () {
      return this.$route.query.id
    },
    // 用户姓名
    fullName () {
      if (!this.profileUser) { return '用户' }
      if (this.isFactoryAccount) {
        return this.profileUser.fullName ? this.profileUser.fullName : (this.profileUser.name ? this.profileUser.name : '用户')
      }
      return this.profileUser.name ? this.profileUser.name : '用户'
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    },
    // 用户头像
    avatarSrc () {
      if (!this.profileUser) { return this.defaultImage }
      if (this.profileId === this.userInfo.objectId) {
        return this.userInfo.avatar ? this.userInfo.avatar : this.defaultImage
      } else {
        return this.profileUser.avatar ? this.profileUser.avatar : this.defaultImage
      }
    }
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    /**
       * 页面初始化
       * @date: 2020/4/12
       */
    async getInit () {
      try {
        this.setStatusBar('dark')
        await this.judgeWatchStatus() // 判断关注状态
        await this.getProfileUser() // 获取个人主页用户信息
        await this.getPostsProfile() // 获取个人签名
        await this.getMinePosts() // 获取自己发帖数据
        await this.getMineWatch() // 获取自己关注数据
        await this.getFansWatch() // 获取粉丝数
        if (this.isUpShelf) {
          await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
          await this.getHotList() // 获取热卖榜单数据 （按销量倒序，只获取10条）
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
       * 失去焦点个人介绍提交数据库
       * @date: 2020/4/12
       */
    async getBlur () {
      if (!this.postsProfile) {
        await this.$tkParse.post('/classes/postsProfile', { user: this.profileId, signature: this.signature })
      } else {
        await this.$tkParse.put(`/classes/postsProfile/${this.postsProfile.objectId}`, { signature: this.signature })
      }
    },
    /**
       * 获取个人主页用户信息
       * @date: 2020/4/13
       */
    async getProfileUser () {
      this.profileUser = await this.$tkParse.getData(`/classes/_User/${this.profileId}`)
    },
    /**
       * 获取个人签名
       * @date: 2020/4/13
       */
    async getPostsProfile () {
      let postsProfile = await this.$tkParse.getList('/classes/postsProfile', {
        params: {
          limit: 1,
          where: {
            user: this.profileId
          }
        }
      })
      if (postsProfile.length) {
        this.postsProfile = postsProfile[0]
        this.signature = postsProfile[0].signature ? postsProfile[0].signature : ''
      } else {
        this.signature = ''
        this.postsProfile = null
      }
    },
    /**
       * 判断关注状态
       * @date: 2020/4/13
       */
    async judgeWatchStatus () {
      if (this.profileId === this.userInfo.objectId) { return }
      let watchStatus = await judgePosts('watchPostUser', { userFans: this.userInfo.objectId, author: this.profileId })
      this.watchStatus = watchStatus
      if (this.watchStatus) { this.watchText = '取消关注' } else { this.watchText = '关注' }
    },
    /**
       * / 获取自己发帖数据  postsSum发帖数praiseNum获赞数
       * @date: 2020/4/12
       */
    async getMinePosts () {
      let res = await this.$tkParse.getList('/classes/InformationPosts', {
        params: {
          limit: 10000,
          keys: 'userFans',
          where: {
            author: this.profileId
          }
        }
      })
      if (res.length) {
        this.praiseNum = 0
        this.postsSum = res.length
        res.forEach(s => {
          if (!s.userFans) { s.userFans = [] }
          this.praiseNum += s.userFans.length
        })
      } else {
        this.postsSum = 0
        this.praiseNum = 0
      }
    },
    /**
       * 获取自己关注数据 watchSum关注数
       * @date: 2020/4/12
       */
    async getMineWatch () {
      this.watchSum = await this.statisticsNum('watchPostUser', { userFans: this.profileId })
    },
    /**
       * 获取粉丝数fansSum粉丝数
       * @date: 2020/4/12
       */
    async getFansWatch () {
      this.fansSum = await this.statisticsNum('watchPostUser', { author: this.profileId })
    },
    /**
       * 取消关注或者关注
       * @date: 2020/4/13
       */
    async liftOrWatch () {
      this.watchDisabled = true
      let queryObj = { profileId: this.profileId, isWatch: false }
      let watchStatus = await judgePosts('watchPostUser', { userFans: this.userInfo.objectId, author: this.profileId })
      if (watchStatus) { // 取消关注
        let res = await this.$tkParse.getList(`/classes/watchPostUser`, {
          params: {
            limit: 1,
            where: {
              userFans: this.userInfo.objectId,
              author: this.profileId
            }
          }
        })
        await this.$tkParse.delete(`/classes/watchPostUser/${res[0].objectId}`)
        queryObj.isWatch = false
        this.watchText = '关注'
        this.$tkGlobal.toast.add('取消关注成功')
      } else { // 给关注列表添加数据
        // 数据
        let obj = {
          author: this.profileId,
          userFans: this.userInfo.objectId
        }
        await this.$tkParse.post(`/classes/watchPostUser`, obj)
        this.$tkGlobal.toast.add('关注成功')
        this.watchText = '取消关注'
        queryObj.isWatch = true
      }
      this.$setFlash('watchProfile', queryObj)
      this.$forceUpdate()
      await this.judgeWatchStatus() // 判断关注状态
      setTimeout(e => { this.watchDisabled = false }, 500)
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 热卖榜单数据获取
     * @date: 2020/3/20
     */
    async getHotList () {
      let hotList = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 50,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      if (hotList.length) {
        this.hotList = priceProcessing(hotList.map((s, index) => {
          if (index === 0) { s.tipsImage = 'https://s3.moke.cloud/dianpei/7d7255d0-fe50-4c12-a0bd-63720f199398.png' }
          if (index === 1) { s.tipsImage = 'https://s3.moke.cloud/dianpei/71590c1c-fb0b-43ab-a986-284d089c3098.png' }
          if (index === 2) { s.tipsImage = 'https://s3.moke.cloud/dianpei/2b4660ae-87ff-4e96-8a2d-3bff30a6c0f5.png' }
          return s
        }), this.judgeTimeRule)
      } else {
        this.hotList = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /*个人信息样式*/
  .mine-bg-color {
    .bg-color-level {
      min-width:50px;
      line-height: 13px;
      padding: 3px;
      text-align: center;
      height:17px;
      background:linear-gradient(90deg,rgba(81,78,79,1),rgba(55,55,55,1));
      border-radius:4px;
      font-size: 10px;
      color: rgba(247, 222, 185, 1);
    }
    .comments-area {
      height: 25px;
      width: 90%;
      font-size: 15px;
      min-width: 0;
      overflow-y: auto;
      resize: none;
      /*background-color: rgba(255, 235, 228, 1);*/
      border-radius: 2px;
    }
    .comments-area::placeholder {
      font-size: 15px;
      color: rgba(153, 153, 153, 1);
    }
    .bg-color-edit {
      width: 70px;
      height: 30px;
      line-height: 30px !important;
      background-color: rgba(255, 176, 0, 1);
      border-radius: 15px;
      color: #fff !important;
      margin: 0 !important;
    }
    ::v-deep {
      .tkui-button.disabled {
        opacity: 0.6 !important;
        color: #fff !important;
      }
    }
  }
  /*分割线样式*/
  .mine-line {
    height: 10px;
    background-color: rgba(250, 250, 250, 1);
  }
  /*按钮样式*/
  ::v-deep .tkui-button.primary.border:hover {
    background-color: transparent;
    color: #fff !important;
  }
  /*tab样式*/
  ::v-deep .tkui-tab .tabs-wrap {
    background-color: #fff;
    height: 42px !important;
    border-bottom: 1px solid #f5f5f5;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item {
    font-size: 15px;
    margin-left: 2px !important;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item.active {
    color: #000000 !important;
    font-weight: bold !important;
    font-size: 15px;
  }
  ::v-deep .tkui-tab .tabs-wrap .tab-item.active:before {
    background:linear-gradient(90deg,rgba(255,150,0,1),rgba(255,96,0,1));
    width: 40% !important;
    height: 2px !important;
    left: 30% !important;
  }
  /*特定文字大小*/
  .font-17 {
    font-size: 17px !important;
  }
</style>
